import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import IVButton from '@invideoio/uniformd/components/Button';

interface showMorePropType {
  showMoreAction: Function;
  isPaginationEnded: boolean;
}

const ShowMore = ({ showMoreAction, isPaginationEnded }: showMorePropType) => {
  function handleClick() {
    showMoreAction();
  }

  return (
    <IVButton
      onClick={handleClick}
      className={ivclass(
        'iv-flex',
        'iv-justify-center',
        'iv-items-center',
        'iv-cursor-pointer',
        'iv-h-65 lg:iv-h-65 md:iv-h-65 sm:iv-h-52',
        'iv-rounded-full',
        'iv-bg-transparent ',
        'iv-border-2 iv-border-blue',
        'iv-px-40 lg:iv-py-[14px] lg:iv-px-40 md:iv-py-[14px] md:iv-px-40 sm:iv-px-25',
        'iv-mx-auto',
        'iv-text-blue',
        'iv-text-body-3xl lg:iv-text-body-3xl md:iv-text-body-3xl sm:iv-text-body-2xl',
        'iv-font-bold lg:iv-font-bold',
        'focus:iv-outline-none',
        isPaginationEnded && 'iv-hidden',
      )}
    >
      Show more
    </IVButton>
  );
};

export default ShowMore;
